export const getMainCountries = () => {
  return [
    { code: 'SE', name: 'Sweden' },
    { code: 'DK', name: 'Denmark' },
    { code: 'FI', name: 'Finland' },
    { code: 'NO', name: 'Norway' },
  ];
};

export const mapLegalUnitCodeToName = legalUnitCode => {
  const country = getMainCountries().find(c => c.code === legalUnitCode);
  return country ? country.name : null;
};

export const mapCountryCodeToCountry = countryCode => {
  const country = getMainCountries().find(c => c.code === countryCode);
  return country || null;
};

export const mapCountryNameToCountry = countryName => {
  const country = getMainCountries().find(c => c.name === countryName);
  return country || null;
};
